import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "block" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "block-text" }, "初始数据", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "block block1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "block-text" }, "增补数据", -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_6))
}